type StatusVariant = "success" | "error";

type QrLinkStatusCardProps = {
  variant: StatusVariant;
  iconClass: string;
  title: string;
  description: string;
  errorDetail?: string;
  homeLabel?: string;
  onGoHome?: () => void;
};

const variantStyles = {
  success: {
    iconBg: "bg-green-100",
    iconColor: "text-green-600",
  },
  error: {
    iconBg: "bg-red-100",
    iconColor: "text-red-500",
  },
};

export default function QrLinkStatusCard({
  variant,
  iconClass,
  title,
  description,
  errorDetail,
  homeLabel,
  onGoHome,
}: QrLinkStatusCardProps) {
  const styles = variantStyles[variant];
  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 to-purple-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-sm w-full text-center">
        <div
          className={`w-20 h-20 ${styles.iconBg} rounded-full flex items-center justify-center mx-auto mb-6`}
        >
          <i
            className={`${iconClass} ${variant === "success" ? "text-5xl" : "text-4xl"} ${styles.iconColor}`}
          ></i>
        </div>
        <h1
          className={`${variant === "success" ? "text-2xl" : "text-xl"} font-bold text-gray-900 mb-2`}
        >
          {title}
        </h1>
        <p className="text-gray-600 text-sm mb-6">{description}</p>
        {errorDetail && (
          <p className="text-red-500 text-sm mb-4">{errorDetail}</p>
        )}
        {homeLabel && onGoHome && (
          <button
            onClick={onGoHome}
            className="w-full flex items-center justify-center gap-2 bg-gray-100 text-gray-700 py-3 rounded-xl font-medium hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            {homeLabel}
          </button>
        )}
      </div>
    </div>
  );
}
